import "@/App.css";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { SoundProvider } from "./contexts/SoundContext";
import Navbar from "./components/Navbar";
import Landing from "./pages/Landing";
import Lobby from "./pages/Lobby";
import Play from "./pages/Play";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";
import Replay from "./pages/Replay";
import Daily from "./pages/Daily";
import AuthCallback from "./pages/AuthCallback";

function AppShell() {
  const location = useLocation();
  // Detect session_id in URL hash synchronously
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/lobby" element={<Lobby />} />
        <Route path="/play" element={<Play />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/replay/:id" element={<Replay />} />
        <Route path="/daily" element={<Daily />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <div className="App min-h-screen">
      <ThemeProvider>
        <SoundProvider>
          <HashRouter>
            <AuthProvider>
              <AppShell />
            </AuthProvider>
          </HashRouter>
        </SoundProvider>
      </ThemeProvider>
    </div>
  );
}
